import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpGet, httpPost, httpPut } from "../../services/httpService";
import {
  getUserDataUrl,
  updateUserByUserEmailUrl,
  updateIsActiveByUserEmailUrl,
  updateIsVerifyByUserEmailUrl,
  updateIsActiveByUserEmailUrlCode,
  getEmailByInvitationCodeUrl,
  getUserForOrbitUrl,
  resendEmailToUserUrl,
  userChangePasswordUrl,
  getUserCertificateUrl,
  acceptTermsAndConditionsUrl,
  getTermsAndConditionsPdfUrl,
  getInviteMemberLogsUrl,
  reinviteEmailToUserUrl,
} from "../../apiUrls/apiUrls";

const initialState = {
  isonboardingVerificationLoading: false,
  userData: {
    userId: "00000000-0000-0000-0000-000000000000",
    companyID: "00000000-0000-0000-0000-000000000000",
    emailAddress: "",
    gender: 0,
    isNew: false,
    firstName: "",
    lastName: "",
    userImage: "",
    gphcNumber: "",
    phoneNumber: "",
    accountType: 1,
    isVerified: false,
    isActive: false,
    password: "",
    role: null,
    newCompanyID: null,
  },
  profileImage: null,
  invitationEmailAddress: "",
  isEmailResend: false,
  isChangePassword: false,
  signupForm: false,
  emailVerification: false,
  yotiSteps: false,
  processingApp: false,
  linkLoading: false,
  onboardringSuccess: false,
  isGetUserCertificateLoading: false,
  userCertificate: null,
  isAcceptingTerms: false,
  termsAccepted: false,
  termsAcceptedAt: null,
  isDownloadingTermsPdf: false,
  termsFileBase64: null,
  inviteMemberLogsData: null,
  isInviteMemberLogsLoading: false,
  titanCodeResponse: "",
};

export const getUserData = createAsyncThunk(
  "onboardingVerification/getUserData",
  async (userEmail) => {
    const respData = await httpGet(getUserDataUrl(userEmail));
    return respData;
  },
);

export const getEmailByInvitationCodeData = createAsyncThunk(
  "onboardingVerification/getEmailByInvitationCodeData",
  async (invitationCode) => {
    const respData = await httpGet(getEmailByInvitationCodeUrl(invitationCode));
    return respData;
  },
);
export const getInviteMemberLogsData = createAsyncThunk(
  "onboardingVerification/getInviteMemberLogsData",
  async () => {
    const respData = await httpGet(getInviteMemberLogsUrl());
    return respData;
  },
);
export const getUserForOrbitData = createAsyncThunk(
  "onboardingVerification/getUserForOrbitData",
  async () => {
    const respData = await httpGet(getUserForOrbitUrl());
    return respData;
  },
);
export const updateUserByUserEmailData = createAsyncThunk(
  "onboardingVerification/updateUserByUserEmailData",
  async (params) => {
    const { userData, userEmail } = params || {};
    const respData = await httpPost(
      updateUserByUserEmailUrl(userEmail),
      userData,
    );
    return respData;
  },
);
export const resendEmailToUserData = createAsyncThunk(
  "onboardingVerification/resendEmailToUserData",
  async (userEmail) => {
    const respData = await httpGet(resendEmailToUserUrl(userEmail));
    return respData;
  },
);

export const reinviteEmailToUserData = createAsyncThunk(
  "onboardingVerification/reinviteEmailToUserData",
  async (memberId) => {
    const respData = await httpGet(reinviteEmailToUserUrl(memberId));
    return respData;
  },
);
export const userChangePasswordData = createAsyncThunk(
  "onboardingVerification/userChangePasswordData",
  async (userEmail) => {
    const respData = await httpGet(userChangePasswordUrl(userEmail));
    return respData;
  },
);

export const updateIsActiveByUserEmailData = createAsyncThunk(
  "onboardingVerification/updateIsActiveByUserEmailData",
  async (params) => {
    const { userEmail, code } = params || {};
    const respData = await httpPost(
      updateIsActiveByUserEmailUrl(userEmail, code),
    );
    return respData;
  },
);

export const updateIsActiveByUserEmailDataCode = createAsyncThunk(
  "onboardingVerification/updateIsActiveByUserEmailDataCode",
  async (params) => {
    const { code } = params || {};
    const respData = await httpPost(updateIsActiveByUserEmailUrlCode(code));
    return respData;
  },
);

export const updateIsVerifyByUserEmailData = createAsyncThunk(
  "onboardingVerification/updateIsVerifyByUserEmailData",
  async (params) => {
    const { userEmail, userData } = params;
    const respData = await httpPost(
      updateIsVerifyByUserEmailUrl(userEmail),
      userData,
    );
    return respData;
  },
);

export const getUserCertificateData = createAsyncThunk(
  "onboardingVerification/getUserCertificateData",
  async () => {
    const respData = await httpGet(getUserCertificateUrl());
    return respData;
  },
);

export const acceptTermsAndConditionsData = createAsyncThunk(
  "onboardingVerification/acceptTermsAndConditionsData",
  async (data, thunkApi) => {
    const url = acceptTermsAndConditionsUrl();
    const respData = await httpPut(url, data);
    return respData;
  },
);

export const getTermsAndConditionsPdfData = createAsyncThunk(
  "onboardingVerification/getTermsAndConditionsPdfData",
  async (fileName) => {
    const url = getTermsAndConditionsPdfUrl(fileName);
    const respData = await httpGet(url);
    return respData;
  },
);

export const onboardingVerificationSlice = createSlice({
  name: "onboardingVerification",
  initialState,
  reducers: {
    setIsOnboardingVerificationLoading: (state, action) => {
      state.isonboardingVerificationLoading = action?.payload || false;
    },
    setUserData: (state, action) => {
      state.userData = action?.payload || null;
    },
    setImage: (state, action) => {
      state.profileImage = action?.payload || null;
    },
    setSignupFormData: (state, action) => {
      state.signupForm = action?.payload || false;
    },
    setEmailVerificationData: (state, action) => {
      state.emailVerification = action?.payload || false;
    },
    setYotiStepsData: (state, action) => {
      state.yotiSteps = action?.payload || false;
    },
    setProcessingAppData: (state, action) => {
      state.processingApp = action?.payload || false;
    },
    setLinkLoadingData: (state, action) => {
      state.linkLoading = action?.payload || false;
    },
    setOnboardingSuccessData: (state, action) => {
      state.onboardringSuccess = action?.payload || false;
    },
    setTermsAcceptedData: (state, action) => {
      state.termsAccepted = action?.payload || false;
    },
    resetOnboardingVerificationState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserData.pending, (state) => {
        state.isonboardingVerificationLoading = true;
        state.userData = {
          userId: "00000000-0000-0000-0000-000000000000",
          companyID: "00000000-0000-0000-0000-000000000000",
          emailAddress: "",
          gender: 0,
          isNew: false,
          firstName: "",
          lastName: "",
          userImage: "",
          gphcNumber: "",
          phoneNumber: "",
          accountType: 1,
          isVerified: false,
          isActive: false,
          password: "",
          role: null,
          newCompanyID: null,
        };
      })
      .addCase(getUserData.fulfilled, (state, action) => {
        state.isonboardingVerificationLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse != null) {
          const {
            firstName,
            lastName,
            userImage,
            gphcNumber,
            phoneNumber,
            accountType,
            isVerified,
            isActive,
            userId,
            companyID,
            emailAddress,
            gender,
            isNew,
            role,
            newCompanyID,
          } = appDataFromResponse || {};

          const user = {
            firstName: firstName,
            lastName: lastName,
            userImage: userImage,
            gphcNumber: gphcNumber,
            phoneNumber: phoneNumber,
            accountType: accountType,
            isVerified: isVerified ? isVerified : false,
            isActive: isActive,
            userId: userId,
            companyID: companyID,
            emailAddress: emailAddress,
            gender: gender,
            isNew: isNew,
            password: "",
            role: role,
            newCompanyID: newCompanyID,
          };
          state.profileImage = userImage;
          state.userData = user;
        } else {
          state.userData = {
            userId: "00000000-0000-0000-0000-000000000000",
            companyID: "00000000-0000-0000-0000-000000000000",
            emailAddress: "",
            gender: 0,
            isNew: false,
            firstName: "",
            lastName: "",
            userImage: "",
            gphcNumber: "",
            phoneNumber: "",
            accountType: 1,
            isVerified: false,
            isActive: false,
            password: "",
            role: null,
            newCompanyID: null,
          };
        }
      })
      .addCase(getUserData.rejected, (state, action) => {
        state.isonboardingVerificationLoading = false;
        state.userData = {
          userId: "00000000-0000-0000-0000-000000000000",
          companyID: "00000000-0000-0000-0000-000000000000",
          emailAddress: "",
          gender: 0,
          isNew: false,
          firstName: "",
          lastName: "",
          userImage: "",
          gphcNumber: "",
          phoneNumber: "",
          accountType: 1,
          isVerified: false,
          isActive: false,
          password: "",
          role: null,
          newCompanyID: null,
        };
      })
      .addCase(resendEmailToUserData.pending, (state) => {
        state.isonboardingVerificationLoading = true;
        state.isEmailResend = false;
      })
      .addCase(resendEmailToUserData.fulfilled, (state, action) => {
        state.isonboardingVerificationLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse != null) {
          state.isEmailResend = true;
        }
      })
      .addCase(resendEmailToUserData.rejected, (state, action) => {
        state.isonboardingVerificationLoading = false;
        state.isEmailResend = false;
      })
      .addCase(reinviteEmailToUserData.pending, (state) => {
        state.isonboardingVerificationLoading = true;
        state.isEmailResend = false;
      })
      .addCase(reinviteEmailToUserData.fulfilled, (state, action) => {
        state.isonboardingVerificationLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse != null) {
          state.isEmailResend = true;
        }
      })
      .addCase(reinviteEmailToUserData.rejected, (state, action) => {
        state.isonboardingVerificationLoading = false;
        state.isEmailResend = false;
      })
      .addCase(userChangePasswordData.pending, (state) => {
        state.isonboardingVerificationLoading = true;
        state.isChangePassword = false;
      })
      .addCase(userChangePasswordData.fulfilled, (state, action) => {
        state.isonboardingVerificationLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse != null) {
          state.isChangePassword = true;
        }
      })
      .addCase(userChangePasswordData.rejected, (state, action) => {
        state.isonboardingVerificationLoading = false;
        state.isChangePassword = false;
      })
      .addCase(getEmailByInvitationCodeData.pending, (state) => {
        state.isonboardingVerificationLoading = true;
        state.userData = {
          userId: "00000000-0000-0000-0000-000000000000",
          companyID: "00000000-0000-0000-0000-000000000000",
          emailAddress: "",
          gender: 0,
          isNew: false,
          firstName: "",
          lastName: "",
          userImage: "",
          gphcNumber: "",
          phoneNumber: "",
          accountType: 1,
          isVerified: false,
          isActive: false,
          password: "",
          role: null,
          newCompanyID: null,
        };
      })
      .addCase(getEmailByInvitationCodeData.fulfilled, (state, action) => {
        state.isonboardingVerificationLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse != null) {
          if (appDataFromResponse != null) {
            const {
              firstName,
              lastName,
              userImage,
              gphcNumber,
              phoneNumber,
              accountType,
              isVerified,
              isActive,
              userId,
              companyID,
              emailAddress,
              gender,
              isNew,
              role,
              newCompanyID,
            } = appDataFromResponse || {};

            const user = {
              firstName: firstName,
              lastName: lastName,
              userImage: userImage,
              gphcNumber: gphcNumber,
              phoneNumber: phoneNumber,
              accountType: accountType,
              isVerified: isVerified ? isVerified : false,
              isActive: isActive,
              userId: userId,
              companyID: companyID,
              emailAddress: emailAddress,
              gender: gender,
              isNew: isNew,
              password: "",
              role: role,
              newCompanyID: newCompanyID,
            };
            state.profileImage = userImage;
            state.userData = user;
          } else {
            state.userData = {
              userId: "00000000-0000-0000-0000-000000000000",
              companyID: "00000000-0000-0000-0000-000000000000",
              emailAddress: "",
              gender: 0,
              isNew: false,
              firstName: "",
              lastName: "",
              userImage: "",
              gphcNumber: "",
              phoneNumber: "",
              accountType: 1,
              isVerified: false,
              isActive: false,
              password: "",
              role: null,
              newCompanyID: null,
            };
          }
        }
      })
      .addCase(getEmailByInvitationCodeData.rejected, (state, action) => {
        state.isonboardingVerificationLoading = false;
        state.userData = {
          userId: "00000000-0000-0000-0000-000000000000",
          companyID: "00000000-0000-0000-0000-000000000000",
          emailAddress: "",
          gender: 0,
          isNew: false,
          firstName: "",
          lastName: "",
          userImage: "",
          gphcNumber: "",
          phoneNumber: "",
          accountType: 1,
          isVerified: false,
          isActive: false,
          password: "",
          role: null,
          newCompanyID: null,
        };
      })
      .addCase(getUserForOrbitData.pending, (state) => {
        state.isonboardingVerificationLoading = true;
        state.userData = {
          userId: "00000000-0000-0000-0000-000000000000",
          companyID: "00000000-0000-0000-0000-000000000000",
          emailAddress: "",
          gender: 0,
          isNew: false,
          firstName: "",
          lastName: "",
          userImage: "",
          gphcNumber: "",
          phoneNumber: "",
          accountType: 1,
          isVerified: false,
          isActive: false,
          password: "",
          role: null,
          newCompanyID: null,
        };
      })
      .addCase(getUserForOrbitData.fulfilled, (state, action) => {
        state.isonboardingVerificationLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse != null) {
          state.userData = {
            userId: "00000000-0000-0000-0000-000000000000",
            companyID: "00000000-0000-0000-0000-000000000000",
            emailAddress: appDataFromResponse.emailAddress,
            gender: 0,
            isNew: false,
            firstName: appDataFromResponse?.firstName ?? "",
            lastName: appDataFromResponse?.lastName ?? "",
            userImage: "",
            gphcNumber: appDataFromResponse?.gphcNumber ?? "",
            phoneNumber: appDataFromResponse?.phoneNumber ?? "",
            accountType: appDataFromResponse.accountType ?? 1,
            isVerified: false,
            isActive: false,
            password: "",
            role: appDataFromResponse?.role ?? null,
            newCompanyID: null,
          };
        }
      })
      .addCase(getUserForOrbitData.rejected, (state, action) => {
        state.isonboardingVerificationLoading = false;
        state.userData = {
          userId: "00000000-0000-0000-0000-000000000000",
          companyID: "00000000-0000-0000-0000-000000000000",
          emailAddress: "",
          gender: 0,
          isNew: false,
          firstName: "",
          lastName: "",
          userImage: "",
          gphcNumber: "",
          phoneNumber: "",
          accountType: 1,
          isVerified: false,
          isActive: false,
          password: "",
          role: null,
          newCompanyID: null,
        };
      })
      .addCase(updateUserByUserEmailData.pending, (state) => {
        // Keep the in-progress user data intact while the update request is in
        // flight. Blanking it here caused the signup route to briefly render the
        // 404 page (SignUp.jsx treats an empty emailAddress as "not found").
        state.isonboardingVerificationLoading = true;
      })
      .addCase(updateUserByUserEmailData.fulfilled, (state, action) => {
        state.isonboardingVerificationLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse != null) {
          const {
            firstName,
            lastName,
            userImage,
            gphcNumber,
            phoneNumber,
            accountType,
            isVerified,
            isActive,
            userId,
            companyID,
            emailAddress,
            gender,
            isNew,
            role,
            newCompanyID,
          } = appDataFromResponse || {};
          const user = {
            firstName: firstName,
            lastName: lastName,
            userImage: userImage,
            gphcNumber: gphcNumber,
            phoneNumber: phoneNumber,
            accountType: accountType,
            isVerified: isVerified ? isVerified : false,
            isActive: isActive,
            userId: userId,
            companyID: companyID,
            emailAddress: emailAddress,
            gender: gender,
            isNew: isNew,
            password: "",
            role: role,
            newCompanyID: newCompanyID,
          };
          state.profileImage = userImage;
          state.userData = user;
        }
      })
      .addCase(updateUserByUserEmailData.rejected, (state) => {
        // Leave userData untouched so the user stays on the signup form (not the
        // 404 page) and can retry after a failed update.
        state.isonboardingVerificationLoading = false;
      })
      .addCase(updateIsActiveByUserEmailData.pending, (state) => {
        state.isonboardingVerificationLoading = true;
        state.userData = {
          userId: "00000000-0000-0000-0000-000000000000",
          companyID: "00000000-0000-0000-0000-000000000000",
          emailAddress: "",
          gender: 0,
          isNew: false,
          firstName: "",
          lastName: "",
          userImage: "",
          gphcNumber: "",
          phoneNumber: "",
          accountType: 1,
          isVerified: false,
          isActive: false,
          password: "",
          role: null,
          newCompanyID: null,
        };
      })
      .addCase(updateIsActiveByUserEmailData.fulfilled, (state, action) => {
        state.isonboardingVerificationLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse != null) {
          const {
            firstName,
            lastName,
            userImage,
            gphcNumber,
            phoneNumber,
            accountType,
            isVerified,
            isActive,
            userId,
            companyID,
            emailAddress,
            gender,
            isNew,
            role,
            newCompanyID,
          } = appDataFromResponse || {};
          const user = {
            firstName: firstName,
            lastName: lastName,
            userImage: userImage,
            gphcNumber: gphcNumber,
            phoneNumber: phoneNumber,
            accountType: accountType,
            isVerified: isVerified ? isVerified : false,
            isActive: isActive,
            userId: userId,
            companyID: companyID,
            emailAddress: emailAddress,
            gender: gender,
            isNew: isNew,
            password: "",
            role: null,
            newCompanyID: newCompanyID,
          };
          state.profileImage = userImage;
          state.userData = user;
        }
      })
      .addCase(updateIsActiveByUserEmailData.rejected, (state, action) => {
        state.isonboardingVerificationLoading = false;
        state.userData = {
          userId: "00000000-0000-0000-0000-000000000000",
          companyID: "00000000-0000-0000-0000-000000000000",
          emailAddress: "",
          gender: 0,
          isNew: false,
          firstName: "",
          lastName: "",
          userImage: "",
          gphcNumber: "",
          phoneNumber: "",
          accountType: 1,
          isVerified: false,
          isActive: false,
          password: "",
          role: null,
          newCompanyID: null,
        };
      })
      .addCase(updateIsActiveByUserEmailDataCode.pending, (state) => {
        state.isonboardingVerificationLoading = true;
      })
      .addCase(updateIsActiveByUserEmailDataCode.fulfilled, (state, action) => {
        state.isonboardingVerificationLoading = false;
        state.titanCodeResponse = action.payload;
      })
      .addCase(updateIsActiveByUserEmailDataCode.rejected, (state, action) => {
        state.isonboardingVerificationLoading = false;
      })
      .addCase(updateIsVerifyByUserEmailData.pending, (state) => {
        // Keep the in-progress user data intact while the verify request is in
        // flight. Blanking it here caused the signup route to briefly render the
        // 404 page (SignUp.jsx treats an empty emailAddress as "not found").
        state.isonboardingVerificationLoading = true;
      })
      .addCase(updateIsVerifyByUserEmailData.fulfilled, (state, action) => {
        state.isonboardingVerificationLoading = false;
        const appDataFromResponse = action?.payload;
        if (appDataFromResponse != null) {
          const {
            firstName,
            lastName,
            userImage,
            gphcNumber,
            phoneNumber,
            accountType,
            isVerified,
            isActive,
            userId,
            companyID,
            emailAddress,
            gender,
            isNew,
            role,
            newCompanyID,
          } = appDataFromResponse || {};
          const user = {
            firstName: firstName,
            lastName: lastName,
            userImage: userImage,
            gphcNumber: gphcNumber,
            phoneNumber: phoneNumber,
            accountType: accountType,
            isVerified: isVerified ? isVerified : false,
            isActive: isActive,
            userId: userId,
            companyID: companyID,
            emailAddress: emailAddress,
            gender: gender,
            isNew: isNew,
            password: "",
            role: role,
            newCompanyID: newCompanyID,
          };
          state.profileImage = userImage;
          state.userData = user;
        }
      })
      .addCase(updateIsVerifyByUserEmailData.rejected, (state) => {
        // Leave userData untouched so the user stays on the onboarding success
        // screen (not the 404 page) and can retry after a failed verify.
        state.isonboardingVerificationLoading = false;
      })
      .addCase(getUserCertificateData.pending, (state) => {
        state.isGetUserCertificateLoading = true;
      })
      .addCase(getUserCertificateData.fulfilled, (state, action) => {
        state.isGetUserCertificateLoading = false;
        state.userCertificate = action?.payload;
      })
      .addCase(getUserCertificateData.rejected, (state, action) => {
        state.isGetUserCertificateLoading = false;
      })
      .addCase(acceptTermsAndConditionsData.pending, (state) => {
        state.isAcceptingTerms = true;
      })
      .addCase(acceptTermsAndConditionsData.fulfilled, (state, action) => {
        state.isAcceptingTerms = false;
        const response = action?.payload;
        if (response) {
          state.termsAccepted = true;
          state.termsAcceptedAt =
            response.termsAcceptedAt || new Date().toISOString();
        }
      })
      .addCase(acceptTermsAndConditionsData.rejected, (state) => {
        state.isAcceptingTerms = false;
      })
      .addCase(getTermsAndConditionsPdfData.pending, (state) => {
        state.isDownloadingTermsPdf = true;
        state.termsFileBase64 = null;
      })
      .addCase(getTermsAndConditionsPdfData.fulfilled, (state, action) => {
        state.isDownloadingTermsPdf = false;
        // action.payload is { success: true, response: { fileContent: "data:...;base64,..." } }
        state.termsFileBase64 = action?.payload?.response?.fileContent || null;
      })
      .addCase(getTermsAndConditionsPdfData.rejected, (state) => {
        state.isDownloadingTermsPdf = false;
        state.termsFileBase64 = null;
      })
      .addCase(getInviteMemberLogsData.pending, (state) => {
        state.isInviteMemberLogsLoading = true;
        state.inviteMemberLogsData = null;
      })
      .addCase(getInviteMemberLogsData.fulfilled, (state, action) => {
        state.isInviteMemberLogsLoading = false;
        state.inviteMemberLogsData = action?.payload;
      })
      .addCase(getInviteMemberLogsData.rejected, (state) => {
        state.isInviteMemberLogsLoading = false;
        state.inviteMemberLogsData = null;
      });
  },
});

export const {
  setUserData,
  setIsOnboardingVerificationLoading,
  setImage,
  setLinkLoadingData,
  setProcessingAppData,
  setYotiStepsData,
  setYotiToolsNeededData,
  setEmailVerificationData,
  setSignupFormData,
  setOnboardingSuccessData,
  resetOnboardingVerificationState,
  setTermsAcceptedData,
} = onboardingVerificationSlice.actions;

export default onboardingVerificationSlice.reducer;
